import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { UploadFile } from 'antd';

import { IPostFormState } from './types';

interface IPostSlice {
	formState: IPostFormState | null;
}

const initialState: IPostSlice = {
	formState: null,
};

export const postSlice = createSlice({
	name: 'post',
	initialState,
	reducers: {
		setFormState: (state, action: PayloadAction<IPostFormState | null>) => {
			state.formState = action.payload;
		},
		addImage: (state, action: PayloadAction<UploadFile>) => {
			state.formState?.images?.push(action.payload);
		},
	},
});

export default postSlice.reducer;

export const { setFormState, addImage } = postSlice.actions;
